import { Heading, Stack, Text, useColorModeValue } from '@ecoinvent/ui';

interface StepHeaderProps {
  step: number;
  totalSteps: number;
  title: string;
  subtitle?: string;
}

const StepHeader = ({ step, totalSteps, title, subtitle }: StepHeaderProps) => {
  const subtitleColor = useColorModeValue('gray.500', 'gray.400');

  return (
    <Stack spacing={2} align="center" textAlign="center">
      <Text fontSize="sm" color={subtitleColor}>
        step {step} of {totalSteps}
      </Text>
      <Heading size="lg" fontWeight="bold">
        {title}
      </Heading>
      {subtitle && (
        <Text fontSize="sm" color={subtitleColor}>
          {subtitle}
        </Text>
      )}
    </Stack>
  );
};

export default StepHeader;
